






























































import {
  getMemberClientIds,
  getClientsByIds,
  getClientId,
  getMemberClientsConfiguration,
  updateMemberClientsHyDryDeviceSettings
} from "@/data/repository/ClientRepository";
import { Vue, Component, Ref } from "vue-property-decorator";
import Client, { 
  MemberClientsConfiguration, 
  createDefaultMemberClientsConfiguration,
} from "@/data/models/Client";
import router from "@/router/router";
import PickerDialogComponent from "@/components/common/PickerDialog.vue";
import MultiSelectionPickerComponent from "@/components/common/MultiSelectionPicker.vue";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";
import { COLOR_BUTTON_SETTINGS_SAVE, COLOR_BUTTON_SETTINGS_EDIT } from "@/utils/colors";
import { themedFill, themedFillTextClass } from "@/utils/Theme";

@Component({
  components: {
    picker: PickerDialogComponent,
    "confirmation-dialog": ConfirmationDialogComponent,
    "multi-selection-picker": MultiSelectionPickerComponent,
  },
})
export default class HyDryDeviceSettingsAdministrationComponent extends Vue {
  isLoading = false;
  isIntiallyLoading = true;
  isEditMode = false;

  yesNoValues = [true, false];
  memberClients = new Map<string, Client>();

  memberClientsConfiguration: MemberClientsConfiguration = createDefaultMemberClientsConfiguration();
  initialHyDryDeviceSettingsAdministration = this.getHyDryDeviceSettingsAdministration();

  selectableClients = this.memberClientIds;

  showingSuccessSnackbar = false;
  successSnackbarText = "";

  @Ref("confirm")
  confirmationDialogComponent!: ConfirmationDialogComponent;

  get buttonColor() {
    return themedFill(this.isEditMode
      ? COLOR_BUTTON_SETTINGS_SAVE
      : COLOR_BUTTON_SETTINGS_EDIT);
  }

  get buttonTextClass() {
    return themedFillTextClass(this.isEditMode
      ? COLOR_BUTTON_SETTINGS_SAVE
      : COLOR_BUTTON_SETTINGS_EDIT, "white--text");
  }

  get hasChanged() {
    return (
      this.memberClientsConfiguration.defineOwnHyDryDeviceSettings !== this.initialHyDryDeviceSettingsAdministration.defineOwnHyDryDeviceSettings ||
      this.memberClientsConfiguration.memberClientsWithOwnHyDryDeviceSettings !== this.initialHyDryDeviceSettingsAdministration.memberClientsWithOwnHyDryDeviceSettings
    );
  }

  get readonly() {
    return !this.isEditMode;
  }

  get memberClientIds() {
    return getMemberClientIds().filter(id => id !== getClientId());
  }

  get showMemberClientsSelector() {
    return this.memberClientsConfiguration.defineOwnHyDryDeviceSettings;
  }

  getHyDryDeviceSettingsAdministration() {
    return {
      defineOwnHyDryDeviceSettings: this.memberClientsConfiguration?.defineOwnHyDryDeviceSettings,
      memberClientsWithOwnHyDryDeviceSettings: this.memberClientsConfiguration?.memberClientsWithOwnHyDryDeviceSettings
    };
  }

  get formatYesNo() {
    return (value: boolean) => {
      return this.$t(`common.${value ? "yes" : "no"}`).toString();
    };
  }

  get selectableClientsFormatter() {
    return (memberClientId: string) => {
      const client = this.memberClients.get(memberClientId);

      if (!client) {
        return null;
      }

      const clientName =
        !client.companyName || client.companyName === ""
          ? client.clientName
          : client.companyName;

      return clientName;
    };
  }

  async created() {
    this.isIntiallyLoading = true;
    this.memberClients = await getClientsByIds(this.memberClientIds);
    const activeMemberClientIds = Array.from(this.memberClients.keys());

    this.memberClientsConfiguration = getMemberClientsConfiguration(activeMemberClientIds);
    this.initialHyDryDeviceSettingsAdministration = this.getHyDryDeviceSettingsAdministration();
    this.isEditMode = false;

    this.isIntiallyLoading = false;
  }

  async onSave() {
    if (!this.isEditMode) {
      this.isEditMode = true;
      return;
    }

    if (!this.hasChanged) {
      return;
    }

    this.isLoading = true;
    const result = await updateMemberClientsHyDryDeviceSettings(this.memberClientIds, this.memberClientsConfiguration);

    this.isLoading = false;
    if (result) {
      this.showingSuccessSnackbar = true;
      this.successSnackbarText = this.$t("common.changesSaved").toString();
      
      this.initialHyDryDeviceSettingsAdministration = this.getHyDryDeviceSettingsAdministration();
      this.isEditMode = false;
    }
  }

  async onBack() {
    if (this.isEditMode) {
      if (this.hasChanged) {
        const result = await this.confirmationDialogComponent.show({
          title: this.$t("common.confirmationDialog.cancelTitle").toString(),
          message: this.$t("common.confirmationDialog.cancelMessage").toString(),
        });

        if (result) {
          this.memberClientsConfiguration.defineOwnHyDryDeviceSettings = this.initialHyDryDeviceSettingsAdministration.defineOwnHyDryDeviceSettings;
          this.memberClientsConfiguration.memberClientsWithOwnHyDryDeviceSettings = this.initialHyDryDeviceSettingsAdministration.memberClientsWithOwnHyDryDeviceSettings;
          this.isEditMode = false;
          return;
        }

        return;
      }

      this.isEditMode = false;
      return;
    }

    router.back();
  }

  mounted() {
    this.setToolbarTitle();
  }

  setToolbarTitle() {
    const baseTitle = this.$t("pages.settings").toString();
    const currentPageTitle = this.$t("settings.administration.hyDryDeviceSettings.title").toString();

    const toolbarTitle = baseTitle + " > " + currentPageTitle;

    ToolbarContentModule.setToolbarTitle(toolbarTitle);
  }
}
